export default __webpack_public_path__ + "img/fkXywtdJ.a6dd905b.svg";